import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import SidebarMenu from "../menu/sidebarMenu";
import PersonalInfoSettings from "./personalInformation";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";

const ProfileSettings = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Profile Update</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <div class="connection-header common-header">
                        <h3>Update profile</h3>
                    </div>
                    <PersonalInfoSettings />
                </div>
            </div>
        </div>

    );
}

export default ProfileSettings;